import { getWindowData } from 'owa-window-data';

export function getHostLocation(): Pick<
    Location,
    'host' | 'protocol' | 'search' | 'hostname' | 'href' | 'hash' | 'pathname' | 'origin' | 'port'
> {
    return getWindowData().location;
}
